import { ISearchQuery } from "../../../shared/hooks/useSearch"
import { CasesActionTypes, IFetchCasesAsyncAction } from "./casesActionTypes"

export const fetchCasesAsync = (searchQuery: ISearchQuery): IFetchCasesAsyncAction => {
  return {
    type: CasesActionTypes.FETCH_CASES_ASYNC_PENDING,
    payload: searchQuery
  }
}
